import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import {CustomEase} from 'gsap/CustomEase';
gsap.registerPlugin( ScrollTrigger, CustomEase );
( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;
    },
    finalize: function() {
    },
    prepareFadeGroup: function( el ) {
      $( el ).find( '> *:not(.js-ignore)' ).each( function( childKey, child ) {
        const delay = ( childKey + 1 ) / 10;
        child.style.setProperty( '--fade-group-delay', delay + 's' );
      } );
    },
    getTriggerEl: function( el ) {
      const customTrigger = el.getAttribute( 'data-animation-trigger' );

      if ( customTrigger ) {
        return el.closest( customTrigger ) || el;
      }

      if ( el.classList.contains( 'animated__component-line-draw' ) ) {
        return el.closest( '[data-component]' ) || el;
      }

      return el;
    },
    animateEl: function( el, force = false ) {
      const delay = force ? 0 : parseInt( el.getAttribute( 'data-animation-delay' ) || 0, 10 );

      if ( $( el ).hasClass( 'js-fade-group' ) ) {
        this.prepareFadeGroup( el );
      }

      if ( delay > 0 ) {
        window.setTimeout( function() {
          $( el ).addClass( 'js-animated' );
        }, delay );
        return;
      }

      $( el ).addClass( 'js-animated' );
    },
    animate: function() {
      if ( !window.matchMedia( '(prefers-reduced-motion)' ).matches ) {
        const _this = this;

        $( `
        .js-fade:not(.js-ignore),
        .js-reveal:not(.js-ignore),
        .js-fade-group,
        .animated__divider-draw:not(.js-ignore),
        .animated__component-line-draw:not(.js-ignore)
        ` ).each( function() {
          gsap.registerPlugin( ScrollTrigger );
          const triggerEl = _this.getTriggerEl( this );
          const tl = gsap.timeline( {
            scrollTrigger: {
              trigger: triggerEl,
              start: 'top 85%',
              scrub: 0.15,
              onRefresh: ( self ) => {
                if ( self.progress > 0 ) {
                  _this.animateEl( this, true );
                }
              },
              onEnter: ( {progress, direction, isActive} ) => {
                _this.animateEl( this );
              },
            },
          } );
        } );
        $( `
          .js-fade.fade-on-load:not(.js-ignore),
          .js-reveal.fade-on-load:not(.js-ignore),
          .js-fade-group.fade-on-load,
          .animated__divider-draw.fade-on-load:not(.js-ignore),
          .animated__component-line-draw.fade-on-load:not(.js-ignore)
          ` ).each( function() {
          gsap.registerPlugin( ScrollTrigger );
          const triggerEl = _this.getTriggerEl( this );
          const tl = gsap.timeline( {
            scrollTrigger: {
              trigger: triggerEl,
              start: 'top 100%',
              scrub: 0.15,
              onRefresh: ( self ) => {
                if ( self.progress > 0 ) {
                  _this.animateEl( this, true );
                }
              },
              onEnter: ( {progress, direction, isActive} ) => {
                _this.animateEl( this );
              },
            },
          } );
        } );
      }
    },
    onError: function() {
      document.querySelectorAll( '.js-fade' )?.forEach( ( el ) => {
        el.classList.remove( 'js-fade' );
      } );
    },
  };
  app.registerComponent( 'animations', COMPONENT );
} )( app );
